

<div class="details-img">
    <div class="imgSetting-master" *ngIf="!cover" >
        <i class="ri-camera-line" *ngIf="!baseUrl||!fileUrl"></i>
        <img *ngIf="baseUrl&&fileUrl" [src]="imageUrl()">
    </div>

    <div class="imgSetting-master2" *ngIf="cover" >
        <i class="ri-camera-line" *ngIf="!baseUrl||!fileUrl"></i>
        <img *ngIf="baseUrl&&fileUrl" [src]="imageUrl()">
    </div>

    <div class="img-icon-master" *ngIf="!cover" [ngClass]="{'hideEdit': userType === '5'}">
        <i class="ri-edit-2-line"></i>
        <input type="file" #file (change)="uploadFile(file.files)"  id="upload-image" accept="image/*">
<!-- <span *ngIf="progress > 0 && (!baseUrl||!fileUrl)">{{progress}}%</span>   -->
    </div>
    <div class="img-icon-master2" *ngIf="cover" [ngClass]="{'hideEdit': userType === '5'}">
        <i class="ri-edit-2-line"></i>
        <input type="file" #file (change)="uploadFile(file.files)" id="cover-img" accept="image/*">
         <!-- <span *ngIf="progress > 0 && (!baseUrl||!fileUrl)">{{progress}}%</span>   -->
        
    </div>
</div>
